import { PayMode } from '../Shared/invoice-enum'
import { Member } from './FitnessBox/Member';
import { UserMembershipPlan } from './FitnessBox/UserMembershipPlan';
import { PendingInvoice } from './PendingInvoice';
import { User } from './FitnessBox/User';
export class InvoicePrintData {
  InvoiceId: number;
  InvoiceNumber: number;
  InvoiceCode: number;
  InvoiceDate: Date;
  DiscountPerc: number;
  DiscountAmt: number;
  PaidBy: PayMode;
  RecipientID: number;
  PreviousInvoices: PendingInvoice;
  TotalPreviousBalance: number;
  TotalAmount: number;
  BalanceAmount: number;
  PaidAmount: number;
  TotalAmountWithoutGST: number;
  TotalCGSTAmount: number;
  TotalSGSTAmount: number;
  NetTotal: number;
  InvoiceDiscount: number;
  PreparedByUser: User;
  TotalTaxAmount: number;
  TotalIGSTAmount: number;
  IsDiscountEdited: number;
  IsGstIncludedInPrice: boolean;
  InvoiceItems: UserMembershipPlan[];
  Recipient: Member;
  PaymentModes: string;
}
